import { CalendarLineIcon, InviteIcon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EventActions } from 'features/events/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useIsLiveStatus } from 'features/events/hooks/useIsLiveStatus';
import type { TelehealthRequestTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: TelehealthRequestTodo;
};

const EventTodoWidgetItem = ({ className, todo }: P) => {
  const {
    event: { author, dialInInformation, endTime, id, name, role, startTime },
    path,
    status,
    type,
  } = todo;
  const isLive = useIsLiveStatus({ endTime, startTime, status });

  const todoEvent = {
    author,
    dialInInformation,
    endTime,
    id,
    role,
    rsvp: type === 'event_enter' ? ('going' as const) : ('pending' as const),
    startTime,
    status: 'active' as const,
  };

  switch (type) {
    case 'event_enter':
      return (
        <BaseTodoWidgetItem
          className={className}
          description={name}
          icon={<CalendarLineIcon />}
          item={<EventActions event={todoEvent} />}
          path={path}
          tags={isLive ? ['live'] : undefined}
          timeConfig={{ options: { display: 'time', mode: 'at' }, time: startTime }}
          title="Join event"
        />
      );
    case 'event_rsvp':
      return (
        <BaseTodoWidgetItem
          className={className}
          description={name}
          icon={<InviteIcon />}
          item={<EventActions event={todoEvent} />}
          path={path}
          tags={isLive ? ['live'] : undefined}
          timeConfig={{ options: { display: 'full' }, time: startTime }}
          title="Respond to invitation"
        />
      );
  }
};

export default EventTodoWidgetItem;
